import { compose } from 'react-apollo';
import withAnalytics from './withAnalytics';
import { withAuth, AuthStates } from '../auth';

const AuthAnalyticsInterceptor = ({ authUser, authState, analytics }) => {
  if (
    authUser &&
    authUser.sub &&
    (authState === AuthStates.SignedIn ||
      authState === AuthStates.NewPasswordRequired)
  ) {
    const { email, givenName, lastName, phoneNumber, roles, dealer } = authUser;
    const dealerName =
      dealer && dealer.dealerGroup ? dealer.dealerGroup.name : '';

    analytics.identifyUser(authUser.sub);
    analytics.setUserProperties({
      $email: email,
      $givenName: givenName,
      $lastName: lastName,
      $name: `${givenName} ${lastName}`,
      $phone: phoneNumber,
      Role: roles && roles.join(' | '),
      DealerGroup: dealerName
    });
  } else if (authState === AuthStates.SignedOut) {
    analytics.clearUser();
  }

  return null;
};

export default compose(
  withAuth,
  withAnalytics
)(AuthAnalyticsInterceptor);



// WEBPACK FOOTER //
// ./src/analytics/AuthAnalyticsInterceptor.js